/**
 * Datepicker Configuration and Initialization
 * 
 * Centralized setup for jQuery UI datepickers across the application.
 * Extracted from utilities.js to follow Single Responsibility Principle.
 */

import $ from 'jquery';

/**
 * Default datepicker options
 */
export const DEFAULT_DATEPICKER_OPTIONS = {
    dateFormat: "M dd, yy",
    changeMonth: true,
    changeYear: true,
    yearRange: "-114:+0",
    maxDate: "+0d",
    minDate: "-114y",
    showButtonPanel: true,
    closeText: 'Clear'
};

/**
 * Initializes datepickers on .fdatepicker elements
 * Supports custom year_range, max_date, and min_date attributes
 */
export function initializeDatepickers() {
    $(document).on('focus', '.fdatepicker', function (e) {
        const $input = $(this).find('input');

        // Allow customization via data attributes
        const yearRange = $input.attr('year_range') || DEFAULT_DATEPICKER_OPTIONS.yearRange;
        const maxDate = $input.attr('max_date') || DEFAULT_DATEPICKER_OPTIONS.maxDate;
        const minDate = $input.attr('min_date') || DEFAULT_DATEPICKER_OPTIONS.minDate;

        const options = {
            ...DEFAULT_DATEPICKER_OPTIONS,
            yearRange,
            maxDate,
            minDate,
            beforeShow: function () {
                // Handle datepickers inside modals - adjust position
                if ($(this).closest('.reveal-modal').length > 0) {
                    const dp = $(this);
                    setTimeout(function () {
                        dp.data('datepicker').dpDiv.css('top', dp.offset().top - $(window).scrollTop() + dp.height());
                    }, 200);
                }
            },
            onClose: function () {
                const event = arguments.callee.caller.caller.arguments[0];

                // If "Clear" button gets clicked, clear the input
                if ($(event.delegateTarget).hasClass('ui-datepicker-close')) {
                    $(this).val('');
                }

                // Remove Parsley validation errors when datepicker closes
                if ($(this).parent().find("ul.parsley-errors-list").length > 0) {
                    $(this).parent().find("ul.parsley-errors-list").remove();
                }
            }
        };

        $input.datepicker(options);
    });
}
